const seo = [
        {
                name: "share_title",
                label: "SEO - Title",
                widget: "string",
                required: false,
                hint: "Warning: only change if required"
        },
        { name: "description", label: "SEO - Description", widget: "string", i18n: true, required: false, hint: "Kept empty summary is being used" },
        { name: "keywords", label: "SEO - Keywords", widget: "list", required: false, i18n: true ,field:
                {
                name: "keyword", label: "Keyword", widget: "string", i18n: true
                }
        },
        {
                name: "share_default_share_image",
                label: "SEO - Use Default Share Image",
                widget: "boolean",
                required: false,
                hint: "True uses default image from theme settings"
        },
        {
                name: "share_image",
                label: "SEO - Share Image",
                widget: "image",
                media_folder: "/site/assets/images/share/",
                public_folder: "/images/share/",
                required: false,
                hint: "Kept empty feature image is used"
        }
    ]

export default seo;
